import React from 'react';
import {useParams} from "react-router-dom";


const ReportAssistant = () => {

    const params = useParams();

    return (
        <div>
            اینجا دقیقا فرم یه دسته بندی باز شده و دسته بندی شماره:
            {params.id}
            <div>
                            تا چهل سالگی که مغزم خوب کار می کرد، به ریاضیات و پژوهش پرداختم. از چهل تا شصت سالگی که ذهنم ضعیف شده بود به فلسفه روی آوردم و در اواخر که به کلی مغزم کار نمی کرد به سیاست!
                        برتراند راسل
            </div>
        </div>
    );
};

export default ReportAssistant;